module.exports = __webpack_public_path__ + "1fc86893d8b3363a3e900b4bdc2cd6b1.png";